
const textField = (id, title, placeholder, elClass = '', hidden = false) => {
    return `<div class="panel-row" ${hidden ? 'style="display:none"' : ''}>
                <div class="label-wrapper">
                    ${title}
                </div>
                <div class="content-wrapper with-form">
                    <div class="form-field field-text">
                        <div class="form-field-inner with-icon right">
                            <input id="${id}" name="${id}" type="text" class="f-field ${elClass}" value="" placeholder="${placeholder}">
                        </div>
                    </div>
                </div>
            </div>`
}

const radioField = (id, title, items = []) => {

    let itemsElements = ''
    items.forEach((value) => {
        itemsElements += `<input type="radio" id="radio-label-${id}-${value.id}" name="${id}" value="${value.id}" class="hidden">
                        <label class="" for="radio-label-${id}-${value.id}">
                            <span>${value.title}</span>
                        </label>`
    })

    return `<div class="panel-row">
                <div class="label-wrapper">
                    ${title}
                </div>
                <div class="content-wrapper">
                    <div class="radio-block">
                        ${itemsElements}
                    </div>
                </div>
            </div>`
}

const dateField = (id, title, elClass = '', hidden = false) => {
    return `<div class="panel-row" ${hidden ? 'style="display:none"' : ''}>
                <div class="label-wrapper">
                    ${title}
                </div>
                <div class="content-wrapper with-form">
                    <div class="form-field field-text">
                        <div class="form-field-inner with-icon right">
                            <input id="${id}" name="${id}" type="date" class="f-field ${elClass}">
                        </div>
                    </div>
                </div>
            </div>`
}


export default {
    getQueryField: () => textField('q', 'Query', 'Search'),
    getYandexQueryField: () => textField('text', 'Query', 'Search'),
    getGspQueryField: () => textField('mauthors', 'Query authors', 'Search'),
    getLocationField: () => textField('location', 'Location', 'Location'),
    getCategoryField: () => textField('cat', 'Category ID', 'Category ID'),
    getResultsLocationField: () => textField('uule', 'Results Location',  'w+CAIQICIGUnVzc2lh'),
    getGoogleDomainField: () => textField('google_domain', 'Google Domain',  'google.co.ao'),
    getLudocidField: () => textField('ludocid', 'Ludocid',  'ChIJOdRxkYAOSUcRewDsIdT9gb8'),
    getCookiesField: () => textField('cookie', 'Cookies',  'param1=val1&param2=val2'),
    getAdvancedGooglePlaceIDField: () => textField('lsig', 'Advanced google place ID',  'AB86z5W5r155sIcs3jqfYkm9Y8Fp'),
    getTermBySearchField: () => textField('tbs', 'Term By Search',  ''),
    getCitesField: () => textField('cites', 'Cites',  ''),
    getClusterField: () => textField('cluster', 'Cluster',  ''),
    getAfterAuthorTokenField: () => textField('after_author', 'After Author Token',  ''),
    getBeforeAuthorTokenField: () => textField('before_author', 'Before Author Token',  ''),
    getAuthorIDField: () => textField('author_id', 'Author ID',  ''),
    getCitationIDField: () => textField('citation_id', 'Citation ID',  ''),
    getProductIDField: () => textField('product_id', 'Product ID',  ''),
    getDataField: () => textField('data', 'Data',  '!4m5!3m4!1s{data_id}!8m2!3d{latitude}!4d{longitude}'),
    getLatitudeLongitudeField: () => textField('ll', 'Latitude Longitude',  '@{latitude},{longitude},zN'),
    getImageURLField: () => textField('image_url', 'Image URL',  ''),
    getPageField: () => textField('p', 'Page',  ''),
    getFromYearField: () => textField('as_ylo', 'From Year',  '', 'number-filter'),
    getToYearField: () => textField('as_yhi', 'To Year',  '', 'number-filter'),
    getOffsetField: (name) => {
        return textField(name || 'offset', 'Offset',  '', 'number-filter')
    },
    getNumberOfImagesField: (name) => {
        return textField(name || 'ijn', 'Page Number Of Images',  '', 'number-filter', true)
    },
    getTimePeriodMinField: () => dateField('time_period_min', 'Time Period Min',  '', true),
    getTimePeriodMaxField: () => dateField('time_period_max', 'Time Period Max',  '', true),
    getPerPageField: (name) => {
        return textField(name || 'num', 'Results per page',  '', 'number-filter')
    },
    getDeviceField: () => radioField('device', 'Device', [
        {id: 'desktop', title: 'Desktop'},
        {id: 'tablet', title: 'Tablet'},
        {id: 'mobile', title: 'Mobile'},
    ]),
    getSafeSearchField: () => radioField('safeSearch', 'Safe Search', [
        {id: '', title: 'Off'},
        {id: 'moderate', title: 'Moderate'},
        {id: 'strict', title: 'Strict'},
    ]),
    getFlattenResultsField: () => radioField('flatten_results', 'Flatten Results', [
        {id: '1', title: 'Yes'},
        {id: '0', title: 'No'},
    ]),
    getEmptyResultsField: () => radioField('empty_results', 'Empty Results', [
        {id: '1', title: 'Yes'},
        {id: '0', title: 'No'},
    ]),
    getFilterAdultContentField: () => radioField('safe', 'Filter Adult Content', [
        {id: '1', title: 'Yes'},
        {id: '0', title: 'No'},
    ]),
    getFilterField: () => radioField('filter', 'Filter', [
        {id: '1', title: 'Yes'},
        {id: '0', title: 'No'},
    ]),
    getExcludeAutocorrectedQueryField: () => radioField('nfpr', 'Exclude autocorrected query', [
        {id: '1', title: 'Yes'},
        {id: '0', title: 'No'},
    ]),
    getAbstractOnlyField: () => radioField('scisbd', 'Abstract Only', [
        {id: '1', title: 'Yes'},
        {id: '0', title: 'No'},
    ]),
    getCitationsField: () => radioField('as_vis', 'Citations', [
        {id: '1', title: 'Yes'},
        {id: '0', title: 'No'},
    ]),
    getHeaderRow: () => `<div class="form-group">
                        <div class="form-field field-text">
                            <div class="form-field-inner number">
                                <input name="header-key[]" type="text" class="f-field" data-map="text:text" value="" placeholder="Key">
                            </div>
                        </div>
                        <div class="form-field field-text">
                            <div class="form-field-inner">
                                <input name="header-value[]" type="text" class="f-field" data-map="text:text" value="" placeholder="Value">
                            </div>
                        </div>
                        <button type="button" class="close"><i class="icons8-delete"></i></button>
                    </div>`
}